/**
 * Contexto del carro y el hook para leerlo.
 *
 * Esta separado de `carro.tsx` por lo mismo que el de la sesion: el recargado
 * en caliente de Vite solo funciona si un archivo exporta unicamente
 * componentes.
 */
import { createContext, useContext } from 'react';

import type { Carro, ProductoResumen } from '@elcarpintero/compartido';

export interface ValorCarro {
  carro: Carro;
  /** Unidades totales; es lo que muestra el globo de la cabecera. */
  unidades: number;
  agregar(producto: ProductoResumen, cantidad?: number): void;
  cambiarCantidad(sku: string, cantidad: number): void;
  quitar(sku: string): void;
  /** Se llama cuando la compra se concreta, no para "borrar todo" a mano. */
  vaciar(): void;
}

export const ContextoCarro = createContext<ValorCarro | null>(null);

export function useCarro(): ValorCarro {
  const valor = useContext(ContextoCarro);

  if (valor === null) {
    throw new Error('useCarro se uso fuera de <ProveedorCarro>');
  }

  return valor;
}
